module.exports = __webpack_public_path__ + "static/media/India.84046641.png";